import {
  GET_ALL_PRODUCTS_RESPONSE_SUCCESS,
  GET_ALL_PRODUCTS,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
} from "./actionTypes"

export const getAllProducts = () => {
  return {
    type: GET_ALL_PRODUCTS,
  }
}
export const getAllProductsResponseSuccess = payload => ({
  type: GET_ALL_PRODUCTS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createProduct = (payload, toggle) => {
  return {
    type: CREATE_PRODUCT,
    payload: payload,
    toggle,
  }
}

// ------------------------------------- UPDATE --------------------------------------------------------

export const updateProduct = (payload, toggle) => ({
  type: UPDATE_PRODUCT,
  payload: payload,
  toggle,
})

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteProduct = payload => ({
  type: DELETE_PRODUCT,
  payload: payload,
})
